import loadable from '@loadable/component';

// The key insight: Don't use fallbacks during SSR at all
// Instead, directly import the component for SSR
const DynamicVisNav =
    typeof window === 'undefined'
        ? // Server-side: import directly (synchronously)
          // eslint-disable-next-line import/no-dynamic-require
          require('./DynamicVisNav').default
        : // Client-side: use loadable with fallback
          loadable(() => import(/* webpackChunkName: "DynamicVisNavChunks" */ './DynamicVisNav'), {
              fallback: null,
          });

export default DynamicVisNav;
